import {cookie} from '@/imports-files/common/common';

export class NextServerCookies {
  get_auth_cookie(req) {
    return cookie.parse(req ? req.headers.cookie || '' : document.cookie);
  }
}
